import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '../services/currentUser.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const currentUser = inject(CurrentUserService).currentUserValue;

  if (!!currentUser) {
    const { privileges, eulaApproved } = currentUser;
    const shouldViewEula =
      !privileges?.includes('SYSADMIN') &&
      !privileges?.includes('MLADMIN') &&
      privileges?.includes('REPADMIN') &&
      !eulaApproved;

    if (shouldViewEula) {
      inject(Router).navigate(['/acceptEula']);
      return false;
    } else {
      return true;
    }
  }

  inject(Router).navigate(['/login']);
  return false;
};
